/**
 * Soutěž "Nabij si léto" — registration.
 * Every entrant is subscribed to Sendy (so all get the dual-purpose emails);
 * the optional newsletter checkbox only sets the `soutez-povolen-marketing`
 * custom field. On submit we ALWAYS show the photo-instructions panel — the
 * emailed photo (not the Sendy record) is the real entry. Opaque no-cors means
 * only network errors are detectable.
 */
(function () {
  'use strict';

  function clean(v) {
    return String(v == null ? '' : v).replace(/[<>\r\n]/g, '').replace(/^[=+\-@]+/, '').trim();
  }
  function isEmail(v) { return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v); }

  function showMessage(form, type, text) {
    var el = form.querySelector('[data-soutez-message]');
    if (!el) return;
    el.textContent = text;
    el.setAttribute('data-message-type', type);
    el.setAttribute('role', type === 'error' ? 'alert' : 'status');
    el.hidden = false;
  }

  function setLoading(form, on) {
    var btn = form.querySelector('button[type="submit"]');
    if (!btn) return;
    if (on) { btn.dataset.label = btn.textContent; btn.textContent = 'Odesílám…'; btn.disabled = true; }
    else { if (btn.dataset.label) btn.textContent = btn.dataset.label; btn.disabled = false; }
  }

  function tagShopify(form, email, marketingOn) {
    var data = new FormData();
    data.append('form_type', 'customer');
    data.append('utf8', '✓');
    data.append('contact[email]', email);
    if (marketingOn) data.append('contact[accepts_marketing]', 'true');
    data.append('contact[tags]', form.dataset.shopifyTag || 'soutez-nabij-si-leto-2026');
    fetch('/contact', { method: 'POST', body: data, redirect: 'manual' }).catch(function () {});
  }

  function showThanks(form, subject) {
    var thanks = form.parentNode.querySelector('[data-soutez-thanks]');
    if (!thanks) return;
    var email = form.dataset.photoEmail || '';
    var mailto = thanks.querySelector('[data-soutez-mailto]');
    if (mailto) mailto.href = 'mailto:' + email + '?subject=' + encodeURIComponent(subject);
    var ed = thanks.querySelector('[data-soutez-email-display]'); if (ed) ed.textContent = email;
    var sd = thanks.querySelector('[data-soutez-subject-display]'); if (sd) sd.textContent = subject;
    form.hidden = true;
    thanks.hidden = false;
    thanks.focus();
  }

  function handle(e, form) {
    e.preventDefault();

    var hp = form.querySelector('[name="hp"]');
    if (hp && hp.value) return; // honeypot tripped — silently drop

    var firstEl = form.querySelector('[name="firstName"]');
    var lastEl = form.querySelector('[name="lastName"]');
    var emailEl = form.querySelector('[name="email"]');
    var first = clean(firstEl && firstEl.value);
    var last = clean(lastEl && lastEl.value);
    var email = ((emailEl && emailEl.value) || '').trim();
    var rules = form.querySelector('[name="consentRules"]');
    var marketing = form.querySelector('[name="consentMarketing"]');

    if (!first || !last) { showMessage(form, 'error', 'Vyplň prosím jméno i příjmení.'); return; }
    if (!isEmail(email)) { showMessage(form, 'error', 'Zadej prosím platnou e-mailovou adresu.'); return; }
    if (!rules || !rules.checked) { showMessage(form, 'error', 'Pro účast musíš souhlasit se statutem soutěže.'); return; }
    if (!form.dataset.sendyList) {
      showMessage(form, 'error', 'Registrace je dočasně nedostupná. Napiš nám prosím na ' + (form.dataset.photoEmail || 'soutěžní e-mail') + '.');
      return;
    }

    var marketingOn = !!(marketing && marketing.checked);
    var subjectTpl = form.dataset.photoSubject || 'SOUTĚŽ {jmeno}';
    var subject = subjectTpl.replace('{jmeno}', (first + ' ' + last).trim());

    setLoading(form, true);
    showMessage(form, 'info', 'Odesílám přihlášku…');

    var extra = {};
    extra[form.dataset.soutezField || 'soutez'] = 'ano';
    extra[form.dataset.marketingField || 'soutez-povolen-marketing'] = marketingOn ? 'ano' : 'ne';
    if (form.dataset.consentVersion) extra.consent_version = form.dataset.consentVersion;
    // Per-form welcome-email copy (Sendy [email_nadpis,fallback=…] in the shared
    // welcome autoresponder). Lets one list serve competition + newsletter with
    // tailored hero — Sendy has no if-then, only fallback substitution.
    if (form.dataset.emailNadpis) extra.email_nadpis = form.dataset.emailNadpis;
    if (form.dataset.emailLead) extra.email_lead = form.dataset.emailLead;
    if (form.dataset.emailPozn) extra.email_pozn = form.dataset.emailPozn;

    var sub = (window.JackerySendy && window.JackerySendy.subscribe)
      ? window.JackerySendy.subscribe({ email: email, name: (first + ' ' + last).trim(), list: form.dataset.sendyList, extra: extra })
      : Promise.resolve({ ok: false, error: 'network' });

    sub.then(function (res) {
      setLoading(form, false);
      tagShopify(form, email, marketingOn);

      if (res && res.ok === false) {
        // Network failure — do NOT claim success; keep form, offer the email path.
        showMessage(form, 'error', 'Spojení selhalo, ale fotku můžeš poslat i tak na ' + (form.dataset.photoEmail || 'soutěžní e-mail') + ' — předmět "' + subject + '". Tím je účast platná.');
        return;
      }
      if (window.dataLayer) window.dataLayer.push({ event: 'competition_signup' });
      showThanks(form, subject);
    }).catch(function () {
      setLoading(form, false);
      showMessage(form, 'error', 'Něco se pokazilo, ale fotku můžeš poslat na ' + (form.dataset.photoEmail || 'soutěžní e-mail') + ' — předmět "' + subject + '". Tím je účast platná.');
    });
  }

  function init() {
    document.querySelectorAll('form[data-soutez-form]').forEach(function (form) {
      if (form.dataset.soutezInit) return;
      form.dataset.soutezInit = '1';
      form.addEventListener('submit', function (e) { handle(e, form); });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
